import { Outlet, Link } from '@tanstack/react-router';
import { Logo } from '@/components/Logo';

export function AuthLayout() {
  return (
    <div className="grid min-h-dvh place-items-center bg-gradient-to-br from-ocean-700 via-ocean-800 to-ocean-950 px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/welcome" className="mb-8 flex items-center justify-center gap-3 text-white">
          <Logo className="h-10 w-10" />
          <span className="text-2xl font-semibold tracking-tight">DiveLogApp</span>
        </Link>
        <div className="rounded-2xl bg-[var(--card)] p-8 shadow-2xl">
          <Outlet />
        </div>
        <p className="mt-6 text-center text-xs text-ocean-200">
          © {new Date().getFullYear()}{' '}
          <a
            href="https://www.golle-it.de"
            target="_blank"
            rel="noreferrer noopener"
            className="font-medium text-white hover:underline"
          >
            GOLLE Digital Solutions GmbH
          </a>
        </p>
      </div>
    </div>
  );
}
